/**
 * Generates random, agent-themed names for new chat agents.
 * Combines adjectives with agent-related nouns to create memorable names.
 *
 * @returns A randomly generated agent name (e.g., "Keen Analyst", "Nimble Strategist")
 *
 * @example
 * generateAgentName() // => "Brilliant Advisor"
 * generateAgentName() // => "Precise Researcher"
 */
export const generateAgentName = (): string => {
  const adjective = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)];
  const noun = NOUNS[Math.floor(Math.random() * NOUNS.length)];
  return `${adjective} ${noun}`;
};

const ADJECTIVES = [
  // Expertise & Knowledge
  'Keen',
  'Sharp',
  'Brilliant',
  'Insightful',
  'Precise',
  'Thorough',
  'Perceptive',
  'Analytical',
  'Savvy',
  'Astute',
  // Reliability & Trust
  'Trusted',
  'Reliable',
  'Steadfast',
  'Diligent',
  'Devoted',
  'Faithful',
  'Dedicated',
  'Attentive',
  'Vigilant',
  'Resourceful',
  // Speed & Responsiveness
  'Swift',
  'Nimble',
  'Agile',
  'Rapid',
  'Prompt',
  'Ready',
  'Quick',
  'Instant',
  'Responsive',
  'Alert',
  // Personality & Warmth
  'Friendly',
  'Helpful',
  'Curious',
  'Clever',
  'Wise',
  'Thoughtful',
  'Creative',
  'Inventive',
  'Calm',
  'Patient',
];

const NOUNS = [
  // Advisory & Consulting
  'Advisor',
  'Consultant',
  'Counselor',
  'Mentor',
  'Guide',
  'Coach',
  'Strategist',
  'Planner',
  // Research & Analysis
  'Analyst',
  'Researcher',
  'Investigator',
  'Explorer',
  'Detective',
  'Scholar',
  'Examiner',
  'Auditor',
  // Specialized Roles
  'Specialist',
  'Expert',
  'Architect',
  'Engineer',
  'Curator',
  'Librarian',
  'Chronicler',
  'Scribe',
  // Communication & Support
  'Assistant',
  'Companion',
  'Collaborator',
  'Partner',
  'Liaison',
  'Coordinator',
  'Dispatcher',
  'Responder',
  // Leadership & Operations
  'Navigator',
  'Pilot',
  'Sentinel',
  'Guardian',
  'Steward',
  'Warden',
  'Captain',
  'Conductor',
];
